export default __webpack_public_path__ + "static/media/sidebar-icon-airport.c83c64cb.svg";